module.exports = __webpack_public_path__ + "img/b_x.1d9d1123.png";